import { cookies } from '@catalogo/core-cookies';

const { fetch } = require('@catalogo/core-http');
const { getIn } = require('seamless-immutable');

export const setFavorite = async (sku, product, isFavorite, config) => {
  const cookiesData = cookies.getAll();
  const customerId = cookiesData[config?.cookiesKey?.customerId];
  const customerToken = cookiesData[config?.cookiesKey?.customerToken];
  const { name, id: productId } = product || {};
  const { id, images, offers } = sku;
  const method = isFavorite ? 'DELETE' : 'POST';

  const offerList = getIn(offers, ['result'], []);
  const skuId = isFavorite ? `/${id}` : '';

  const image = images.find(image => getIn(image, ['large'], ''));
  const stock = offerList.length <= 0 ? false : true;
  const price = offerList.find(offer => getIn(offer, ['salesPrice'], {}));

  const headers = {
    'Content-Type': 'application/json',
    method,
  };

  const body = JSON.stringify({
    properties: {
      image: getIn(image, ['large'], ''),
      name,
      price: getIn(price, ['salesPrice'], 0),
      productId: productId.toString(),
      stock,
    },
    sku: id.toString(),
  });

  const options = {
    method,
    headers,
  };

  return await fetch(
    `${getIn(config, [
      'endpoints',
      'wishlist',
    ])}/wishlist/product${skuId}?customerId=${customerId}&token=${customerToken}`,
    isFavorite ? options : { ...options, body }
  )
    .then(result => {
      const { status, ok } = result;
      return { method, status, ok };
    })
    .catch(_ => ({ method, status: 500, ok: false }));
};
